// extracted by mini-css-extract-plugin
module.exports = {"playersDetailsContainer":"PlayersPage_playersDetailsContainer__Yig6V"};